import React     from 'react';
import PropTypes from 'prop-types';
import './ProfileRow.scss';

export default function ProfileRow({ icon, label, onClick }) {
  return (
    <button className="profile-row" onClick={onClick}>
      <span className="icon-box">{icon}</span>
      <span className="label">{label}</span>
    </button>
  );
}

ProfileRow.propTypes = {
  icon   : PropTypes.node.isRequired,
  label  : PropTypes.string.isRequired,
  onClick: PropTypes.func
};
